import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { AlertProps } from './index';

export default function WarningAlert(props: Pick<AlertProps, 'label' | 'close'>) {
  const { label, close } = props;
  return (
    <div className="relative flex items-center gap-3 rounded-md bg-yellow-50 p-4">
      <ExclamationTriangleIcon
        className="size-6 flex-shrink-0 text-yellow-400"
        aria-hidden="true"
      />
      <p className="text-sm font-medium text-yellow-700">{label}</p>
      <button
        type="button"
        onClick={close}
        className="inline-flex rounded-md bg-yellow-50 p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-offset-2 focus:ring-offset-yellow-50"
      >
        <span className="sr-only">Dismiss</span>
        <XMarkIcon className="size-5 flex-shrink-0" aria-hidden="true" />
      </button>
    </div>
  );
}
